.wrapper {
	display: flex;
	flex-direction: column;
	gap: 10px;
	align-items: center;
	margin: 50px 0;
	transition: all 0.5s;
}
.hide {
	transform: translateY(20px);
	opacity: 0;
	visibility: hidden;
}

.buttonRow {
	display: flex;
	gap: 10px;
}

.bossBtn {
	background-color: #ef4444;
	&:not(:disabled):hover {
		background-color: #dc2626;
	}
}
.heroBtn {
	background-color: #3b82f6;
	&:not(:disabled):hover {
		background-color: #2563eb;
	}
}
.spectateBtn {
	background-color: #64748b;
	&:not(:disabled):hover {
		background-color: #475569;
	}
}
